import {defineStore} from "pinia";
import {MassCertificationCustomer} from "@/core/interfaces/MassCertification";
import {CommunicationMode} from "@/communication/types";
import {RouteLocationRaw} from "vue-router";
import {NotificationTemplate} from "@/notification-template/interfaces";

export const useCommunicationStore = defineStore('communication', {
    state: () => ({
        customers: [] as MassCertificationCustomer[],
        programCustomers: [] as string[],
        template: null as NotificationTemplate | null,
        content: null as string | null,
        contentCost: 1 as number,
        selectionBatchId: null as string | null,
        programId: null as number | null,
        mode: 'sms' as CommunicationMode,
        from: {name: 'patient-administration.communication.customers'} as RouteLocationRaw | null
    })
});
